import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { submit, getFormValues, isValid } from 'redux-form';
import { BookTour } from '../../actions/booking';
import { SetPassengerDetails, SetBooking, SetTourNameOveride } from '../../actions/currentBooking';
import { store } from '../../index';


class BasketBooking extends PureComponent{

  constructor(props){
    super(props);

    this.state = {
      basketPaxDetails:{},
      termsCheck:false
    }
    this.onBookTour = this.onBookTour.bind(this);
    this.handleTermsChange = this.handleTermsChange.bind(this);
  }


  componentDidCatch(error, info) {
    this.props.history.push('/');
  }

  onBookTour(){

    const {
      BookTour,
      currency:{ iso_currency_code },
      basketType,
      SetPassengerDetails,
      basketPaxValues,
      SetBooking,
      booking,
      iscyoa,
      SetTourNameOveride
    } = this.props;


  if(!booking){

      //Set booking preloader
      SetBooking(true)

      // 1. Save pax in state if currentBooking is reset
      // 2. Set pax details, set tour name and book tour
      this.setState({basketPaxDetails:basketPaxValues}, () => {
        SetPassengerDetails(this.state.basketPaxDetails);

        if(iscyoa) SetTourNameOveride(`${this.state.basketPaxDetails.firstName}'s adventure`);

        BookTour(iso_currency_code, store.getState().currentBooking, basketType, this.state.termsCheck ? true : false, iscyoa);
      });

    }

  }


  handleTermsChange(){
    this.setState({termsCheck: !this.state.termsCheck});
  }

  render(){
    const { basketPaxValid } = this.props;

    return (
      <div className="basket-book-box">
        <div className="row">
          <div className="column small-12">
            <label className="checkbox-container terms-checkbox">
              <span className="payment-info-text">Keep me informed about the progress of my booking. We take the protection of your <a href="https://www.busabout.com/privacy-policy" className="busabout--cta--link orange" target="_blank" rel="noopener noreferrer">personal data</a> seriously.</span>
              <input name="termcheck" type="checkbox"  defaultChecked={this.state.termsCheck} onChange={this.handleTermsChange}/>
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
        <div className="row">
         <div className="column small-12">
           <button
             type="submit"
             className={`busabout--cta orange ${(basketPaxValid) ? '': 'disabled'}` }
             onClick={this.onBookTour}
             disabled={ (basketPaxValid) ? false : true}>
             Start Your Adventure
           </button>
         </div>
       </div>
     </div>
  )
  }
}



function mapStateToProps(state){
  return{
    booking:state.currentBooking.booking,
    currency:state.currency,
    basketPaxValues:getFormValues('BasketPax')(state),
    basketPaxValid: isValid('BasketPax')(state),
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    BookTour,
    submit,
    SetPassengerDetails,
    SetBooking,
    SetTourNameOveride
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BasketBooking);



// WEBPACK FOOTER //
// ./src/components/departure/basketbooking.js